module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-800.a744c22c.ttf";